import React from 'react';
import styled from 'styled-components';
import { translate } from 'base/shared/Localization';
import { BADI_COLORS } from 'app/badi-components';

import { Spacer, Text, Flex } from '@badi/badi-components';
import Image from 'components/Image/Image';
import Support from 'components/Icons/Support';

const TextWithLink = styled(Text)`
  > a {
    color: ${BADI_COLORS.BRAND.SECONDARY.DEFAULT};
    text-decoration: underline;
    font-weight: 700;
    &:hover {
      color: ${BADI_COLORS.BRAND.SECONDARY.HOVER};
    }
  }
`;

const YellowBlock = styled.div`
  background-color: #ffd685;
  padding: 14px;
  border-radius: 16px;
`;

const BookingPhoneCta = () => {
  const phoneNumber = '+34931866275';
  const phoneFormatted = '+34 931 86 62 75';

  return (
    <YellowBlock>
      <Flex justifyContent="justifyBetween" alignItems="center">
        <Spacer right={1}>
          <Support width={'36px'} height={'36px'} color={BADI_COLORS.BRAND.PRIMARY.DEFAULT} />
        </Spacer>
        <Spacer>
          <Text body={2}>{translate('booking.preview.phone_title')}</Text>
          <TextWithLink
            body={3}
            dangerouslySetInnerHTML={{
              __html: translate('booking.preview.phone_cta', {
                phoneNumber: phoneNumber,
                phoneFormatted: phoneFormatted,
              }),
            }}
          />
        </Spacer>
      </Flex>
    </YellowBlock>
  );
};

export default BookingPhoneCta;
